import React from 'react';
import { ButtonProps, Flex } from '@chakra-ui/react';
import PurpleButton from './atoms/buttons/PurpleButton';
import NeutralButton from './atoms/buttons/neutralButton';
import { themeVariables } from '../theme';
import { Image } from '@chakra-ui/react';

const poweredByLogo =
  'https://bjlavcngusgdszvtjwdr.supabase.co/storage/v1/object/public/Images//powered_white_stacked.png';
interface StepButtonsProps {
  pb?: string;
  pt?: string;
  poweredBy?: boolean;
  disableLeft?: boolean;
  disableRight?: boolean;
  leftText?: string;
  rightText: string;
  leftOnclick?: () => void;
  rightOnclick: () => void;
  rightBtnProps?: ButtonProps;
  leftBtnProps?: ButtonProps;
  primaryButtonColor?: string;
  hoverButtonColor?: string;
}

function StepButtons(props: StepButtonsProps) {
  const {
    leftOnclick,
    leftText,
    rightOnclick,
    rightText,
    pb = '1rem',
    pt = '1rem',
    disableLeft = false,
    disableRight = false,
    rightBtnProps = {},
    leftBtnProps = {},
    poweredBy,
    primaryButtonColor,
    hoverButtonColor,
  } = props;
  return (
    <Flex
      gap="8px"
      pb={pb}
      pt={pt}
      height="full"
      mt="auto"
      justify="space-between"
      align="center"
    >
      <Flex>
        {leftText && (
          <NeutralButton
            onClick={leftOnclick}
            disabled={disableLeft}
            width="100%"
            borderRadius="60rem"
            border={`1.5px solid ${themeVariables.purple.metera}`}
            fontSize="0.875rem"
            color={themeVariables.primary.primary50}
            fontWeight="700"
            cursor={disableLeft ? 'not-allowed' : 'pointer'}
            {...leftBtnProps}
          >
            {leftText}
          </NeutralButton>
        )}
      </Flex>

      {rightText && (
        <PurpleButton
          flex="2"
          width="100%"
          onClick={rightOnclick}
          disabled={disableRight}
          cursor={disableRight ? 'not-allowed' : 'pointer'}
          {...rightBtnProps}
          primaryButtonColor={primaryButtonColor}
          hoverButtonColor={hoverButtonColor}
        >
          {rightText}
        </PurpleButton>
      )}
      {poweredBy && (
        <Flex flex={1}>
          <a href="https://test.meteraprotocol.io/" target="blank">
            <img height="80%" src={poweredByLogo} alt="Powered by Metera" />
          </a>
        </Flex>
      )}
    </Flex>
  );
}

export default StepButtons;
